<template>
	<div class="newscenter">
		<div class="bg">
			<img src="@imgs/xwzxbg.png" width="194px" height="93px" alt="" class="cpzx" />
		</div>
		<div class="newscontent">
			<div class="contentbox">
				<div class="left">
					<div class="newslist">
						<div class="newsitem" v-for="item in newsList" :key="item.id">
							<div class="title" @click="toDetails(item.id)">{{item.name}}</div>
							<div class="newsvalue">
								<div>
									{{item.titlie}}
								</div>
								<div>
									{{item.titlie1}}
								</div>
							</div>
							<span>2024-04-08</span>
						</div>
					</div>
				</div>
				<div class="right">
					<div class="search">
						<input type="text" placeholder="搜索" />
						<img src="@imgs/search.png" width="17px" height="17px" alt="" />
					</div>
					<div class="recommend">
						<div class="wntj">为你推荐</div>
						<div class="gd">
							更多<img src="@imgs/gt.png" width="6px" height="11px" alt="" />
						</div>
					</div>
					<div class="recommendlist">
						<div class="item" v-for="item in 4" :key="item.id">
							<div class="square"></div>
							<div class="recomedtitle">
								疫情挡不住温情 富宁县药之家药店用实际行动传递温暖
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				newsList: [{
					id: 0,
					name:'党支部联合开展主题党日活动',
					titlie: "活动",
					titlie1: '本次活动，通过两个党支部的互相学习，面对面的沟通，提高了党员的思想觉悟。活动中，双方深入沟通了上下游合作情况，探讨了银企互利共赢的合作发展方向，为“十四五”期间银行大力支持民营企业经济发展和业务拓展奠定了基础。'
				}, {
					id: 1,
					name:'云红药之家捐赠昆明市慈善总会1万余元',
					titlie:'为支持云南省昆明市地区医疗健康保险的发展，共同为构建和谐社会做出贡献，富宁县药之家药店于3月24日对昆明市慈善总会进行无偿捐赠， 捐赠资产为“春城惠民保保险”，首批捐赠保单600份，价值人民币11400元。',
					titlie1:'富宁县药之家药店在发展过程中，积极承担社会责任，倡导企业、员工、社会共同发展的理念。 近年来，在新冠疫情防控、扶贫攻坚、爱心助学、促进就业等方面发挥着自己的作用，贡献出企业的一份力量。'
				}],
			};
		},
		methods: {
			toDetails(id) {
				this.$router.push({
					path: '/newsdetails',
					query: {
						id: id
					}
				})
			}
		}
	};
</script>

<style lang="scss" scoped>
	.newscenter {

		.newscontent {
			width: 100%;
			height: 1200px;
			background: #f1f1f1;
			padding-top: 30px;

			.contentbox {
				display: flex;
				width: 1200px;
				margin: 0 auto;
				// height: 1073px;
				justify-content: space-between;

				.left {
					width: 817.9px;
					box-sizing: border-box;
					padding: 35px;
					background: #ffffff;
					border-radius: 8px;

					.newslist {
						text-align: left;

						.newsitem {
							font-family: Microsoft YaHei;
							border-bottom: 1px solid #e6e6e6;
							padding-bottom: 28px;
							margin-bottom: 30px;

							&:nth-last-child(1) {
								border: none;
							}

							// &:nth-of-type(1) {
							//   .title {
							//     color: #fe2a1e;
							//   }
							// }
							.title {
								font-size: 24px;

								&:hover {
									color: #fe2a1e;
									cursor: pointer;
								}
							}

							.newsvalue {
								margin-top: 23px;
								margin-bottom: 17px;
								font-size: 18px;
								color: #666565;

								div {
									line-height: 30px;
								}
							}

							span {
								font-size: 18px;
								font-family: DengXian;
								font-weight: bold;
								color: #999999;
							}
						}
					}
				}

				.right {
					width: 353px;
					border-radius: 8px;
					text-align: left;
					padding: 33px;
					height: 478px;
					box-sizing: border-box;
					background: #ffffff;

					.search {
						border: 1px solid #cccccc;
						border-radius: 5px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 11px 15px 8px 15px;

						input {
							flex: 1;
							font-size: 17px;
							outline: none;
							border: none;
						}
					}

					.recommend {
						display: flex;
						justify-content: space-between;
						align-items: center;
						font-weight: 400;
						margin-top: 28px;
						border-bottom: 1px solid #e6e6e6;
						padding-bottom: 9px;

						.wntj {
							font-size: 20px;
							font-family: Microsoft YaHei;
							color: #333333;
						}

						.gd {
							display: flex;
							align-items: center;
							font-size: 18px;
							font-family: DengXian;
							color: #fe2a1e;

							img {
								margin-left: 5px;
							}
						}
					}

					.recommendlist {
						.item {
							padding-bottom: 15px;
							border-bottom: 1px dotted #cccccc;
							margin-top: 17px;
							display: flex;

							// &:nth-last-child(1){
							//   .square{
							//     background: #FE2A1E;
							//   }
							//   .recomedtitle{
							//     color: #FE2A1E;
							//   }
							// }
							&:hover {
								.square {
									background: #fe2a1e;
								}

								.recomedtitle {
									color: #fe2a1e;
								}

								cursor: pointer;
							}

							.square {
								width: 8px;
								height: 6px;
								background: #999999;
								margin-top: 7px;
								margin-right: 5px;
							}

							.recomedtitle {
								color: #666565;
								font-family: Microsoft YaHei;
								font-weight: 400;
								color: #666565;
							}
						}
					}
				}
			}
		}
	}
</style>
